import {reqWithToken} from './requestHelper';

export async function getUnavailables(filter) {
    return (await reqWithToken('api/gxbooking/Unavailables/q',{
        data: {...filter},
        method:'post'
    })).data;
}

export async function deleteUnavailable(id) {
    return (await reqWithToken('api/gxbooking/Unavailables',{
        params:{id},
        method:'delete'
    })).data;
}

export async function deleteUnavailableRange(ids) {
    return (await reqWithToken('api/gxbooking/Unavailables/r',{
        params: ids,
        method:'delete'
    })).data;
}

export async function getVacancyRoomsInRange(params){
    return (await reqWithToken('api/gxbooking/classrooms/vacancyInRange',{
        params
    })).data;
}

export async function getVacancyRoomsInRangeExceptOf(params){
    return (await reqWithToken('api/gxbooking/classrooms/vacancyInRangeExceptOf',{
        params
    })).data;
}

export async function insertUnavailableRange(unavailables) {
    return (await reqWithToken('api/gxbooking/Unavailables/r',{
        data: unavailables,
        method:'post'
    })).data;
}

export async function updateUnavailableRange(unavailable) {
    return (await reqWithToken('api/gxbooking/Unavailables',{
        data: unavailable,
        method:'patch'
    })).data;
}
